import { useId } from "react";

type ProgressBarProps = {
    percent: number;
    label?: string;
};

export function ProgressBar({ percent, label }: Readonly<ProgressBarProps>) {
    const id = useId();
    const clamped = Math.min(100, Math.max(0, percent));

    return (
        <div className="w-full max-w-md">
            <progress
                id={id}
                value={clamped}
                max={100}
                className="
                    h-3 w-full appearance-none overflow-hidden rounded-full
                    bg-gray-200 text-blue-500
                    [&::-webkit-progress-bar]:bg-gray-200
                    [&::-webkit-progress-value]:bg-blue-500
                    [&::-webkit-progress-value]:transition-all
                    [&::-webkit-progress-value]:duration-100
                    [&::-moz-progress-bar]:bg-blue-500
                    mt-5
                "
            />
            {(
                <label htmlFor={id} className="mt-1 block flex w-full !text-[#2C2C2C] !font-inter !text-[16px] justify-between text-[16px]">
                    <span>{label}</span>
                    <span>{Math.round(clamped)}%</span>
                </label>
            )}
        </div>
    );
}